import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {usePrevious} from '~/common/hooks/usePrevious';
import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';

function extractTab(pathname) {
  const components = pathname.split('/');
  if (components.length > 1) return components[components.length - 1] || '/';
  return '/';
}

function useFabricPageViewChange(location) {
  const tab = extractTab(location.pathname);
  const previousTab = usePrevious(tab);

  useEffect(() => {
    if (previousTab !== tab && previousTab !== undefined) {
      if (previousTab !== 'create' || tab !== 'customize') {
        const {pathname} = location;
        // DataOps use this to track pageviews within the app
        window.dataLayer.push({
          event: 'pageview',
          page_title: 'fabric_invitation_create',
          page_path: pathname,
        });
      }
    }

    return undefined;
  }, [location, tab, previousTab]);
}

function useFabricCreateDataLayer(location, eventParent) {
  const pathObj = useCurrentRoute();
  const isPremium = useSelector((state) => state.details.isPremium);
  const isDraft = useSelector((state) => (state.eviteEvent?.status || 'draft') === 'draft');
  const prevIsPremium = usePrevious(isPremium);
  const prevPathName = usePrevious(pathObj.name);

  useEffect(() => {
    if (isDraft && pathObj.name && (prevPathName !== pathObj.name || prevIsPremium !== isPremium)) {
      // We report these events to track the initial conversion funnel
      if (
        (pathObj.name === 'create' || pathObj.name === 'customize') &&
        (prevPathName !== pathObj.name || prevIsPremium !== isPremium)
      ) {
        window.dataLayer.push({event_is_draft: true});
      }
      window.dataLayer.push({
        event: `${eventParent}_${isPremium ? 'premium' : 'free'}_${pathObj.name}`,
        is_fabric_premium: isPremium,
        tracking_product_type: window.tracking_product_type,
      });
    }

    return undefined;
  }, [location, isDraft, pathObj.name, prevPathName, isPremium, prevIsPremium]);
}

/**
 * Reports top level route changes to google analytics.
 * @function useTrackPages
 * @return none
 */
export const useTrackPages = (eventParent = 'fabric_create') => {
  const location = useLocation();

  useFabricPageViewChange(location);
  useFabricCreateDataLayer(location, eventParent);
};
